/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../../core/AppDispatcher'
import { TransactionHeadState } from '../state/TransactionHeadState'
import TransactionEvent from '../../event/TransactionEvent'
import TransactionDetailsStore from './TransactionDetailsStore'

class TransactionHeadStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return new TransactionHeadState()
  }

  reduce(state, action) {
    // 明細の処理が終わってからヘッダの処理を実行する
    AppDispatcher.waitFor([TransactionDetailsStore.getDispatchToken()])

    const payload = action.payload
    let total = 0

    switch (action.type) {
      case TransactionEvent.fetchReservation:
        // 初回ロード時
        return state.clear()

      case TransactionEvent.onEdit:
        const checkboxLabels = ['accommodation_fee_paid', 'accommodation_tax_paid', 'others_paid']
        if (checkboxLabels.includes(payload.name)) {
          return state.set(payload.name, payload.value).set('total', this.calculateTotal())
        }

        return state.set(payload.name, payload.value)

      case TransactionEvent.onEditDetail:
        return state.set('total', this.calculateTotal())

      default:
        return state
    }
  }

  calculateTotal() {
    // TODO Storeがシングルトンになってしまっている・・
    const details = TransactionDetailsStore.getState()
    const total = details.reduce((acc, cur) => {
      const price = cur ? cur.total : 0
      return parseInt(price) + parseInt(acc)
    }, 0)

    return total
  }
}

export default new TransactionHeadStore()
